export default __webpack_public_path__ + "static/media/photo--sm--kickoff1.fd3817fd.jpg";